import React from 'react';
import { useNavigate } from 'react-router-dom';

import { applyTypography, useIsMobile, BaseButton } from '@repo/common';
import { ReactComponent as LeftIcon } from '@repo/common/assets/icons/16px/icon_16px_navigation-left.svg';
import { ReactComponent as ResetIcon } from '@repo/common/assets/icons/20px/icon_20px_reset.svg';

const TXT_TITLE_KEY = 'h5';
const TXT_SUB_KEY = 'b16';
const TXT_EMAIL_KEY = 'b16Strong';

const TXT_MOBILE_TITLE_KEY = 'title1';
const TXT_MOBILE_SUB_KEY = 'b13';
const TXT_MOBILE_EMAIL_KEY = 'b13Strong';

/**
 * 에러 CS 컴포넌트
 */
export const ErrorCS = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const errorCatImageUrl = `${process.env.REACT_APP_ASSETS_URL}/img-cat-error.svg`;
  const email = 'support@ko-ready.com';

  const handleBackButtonClick = () => {
    window.location.href = '/';
  };

  const handleTryButtonClick = () => {
    const hasRetried = sessionStorage.getItem('errorRetried');

    if (hasRetried) {
      sessionStorage.removeItem('errorRetried');
      sessionStorage.removeItem('errorFrom');
      return;
    }

    const errorFrom = sessionStorage.getItem('errorFrom');
    sessionStorage.setItem('errorRetried', 'true');

    if (errorFrom) {
      window.location.href = errorFrom;
    } else {
      window.location.reload();
    }
  };

  return (
    <div className='bg-grayscale-gray01 min-h-screen w-full flex flex-col items-center justify-center text-center px-[24px] md:px-[80px]'>
      {/* Content */}
      <div className='w-full max-w-[570px] pb-[60px] tabletH:px-0'>
        <img
          src={errorCatImageUrl}
          alt='error cat'
          className='max-w-[100px] max-h-[100px] tabletH:max-w-[180px] tabletH:max-h-[170px] mx-auto pb-4 tabletH:pb-5'
        />

        <div
          className={`${applyTypography(TXT_MOBILE_TITLE_KEY)} mb-4 md:hidden`}
        >
          Something went wrong
        </div>

        <div
          className={`${applyTypography(TXT_TITLE_KEY)} mb-4 hidden md:block`}
        >
          Something went wrong
        </div>

        <div
          className={`${applyTypography(TXT_MOBILE_SUB_KEY)} mb-2 md:hidden`}
        >
          It looks like something unexpected happened <br />
          If the issue continues, please let our team know — it helps us fix
          things faster
        </div>

        <div className={`${applyTypography(TXT_SUB_KEY)} mb-2 hidden md:block`}>
          It looks like something unexpected happened <br />
          If the issue continues, please let our team know — it helps us fix
          things faster
        </div>

        <div className={`${applyTypography(TXT_MOBILE_EMAIL_KEY)} md:hidden`}>
          Email us at{' '}
          <span
            className={`
              ${applyTypography(TXT_MOBILE_EMAIL_KEY)}
              text-green-deep04
              inline-block leading-none
              px-1 pb-[6px]
              bg-[linear-gradient(transparent,transparent_40%,rgba(0,158,79,0.4)_40%)]
            `}
          >
            {email}
          </span>
        </div>

        <div className={`${applyTypography(TXT_SUB_KEY)} hidden md:block`}>
          Email us at{' '}
          <span
            className={`
              ${applyTypography(TXT_EMAIL_KEY)}
              text-green-deep04
              inline-block leading-none
              px-1 pb-[6px]
              bg-[linear-gradient(transparent,transparent_40%,rgba(0,158,79,0.4)_40%)]
            `}
          >
            {email}
          </span>
        </div>
      </div>

      {/* Buttons */}
      <div className='w-full max-w-[570px] flex flex-col items-center'>
        <div className='mb-2'>
          <BaseButton
            type='primary'
            isDisabled={!email}
            size={isMobile ? 'l' : 'xl'}
            iconPosition='before'
            icon={<ResetIcon />}
            onClick={handleTryButtonClick}
            width='200px'
          >
            Try again
          </BaseButton>
        </div>

        <div>
          <BaseButton
            type='text'
            size={isMobile ? 'l' : 'xl'}
            iconPosition='before'
            icon={<LeftIcon />}
            onClick={handleBackButtonClick}
            width='169px'
          >
            Go back home
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default ErrorCS;
